module.exports = __webpack_public_path__ + "img/coins.92af1cdb.svg";